import React from "react";
import { FaMagic } from "react-icons/fa";

// Sticky, high-visibility banner pinned to the bottom of the viewport while a
// page is showing sample/demo data. Rendered inside the page tree but
// position:fixed, so it always sits at the screen bottom regardless of where
// it's mounted. On desktop it starts after the 260px MainNav sidebar; on
// mobile (<768px) it spans full width and stacks (text above, button below) so
// nothing is truncated. Pages add bottom spacing while a demo is on screen so
// the last list item never hides behind it.
export default function DemoBanner({
  title = "This is sample data",
  subtitle,
  ctaLabel,
  onCta,
  isMobile = false,
}) {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: isMobile ? 0 : 260,
        right: 0,
        zIndex: 900,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "center",
        gap: isMobile ? 10 : 16,
        padding: isMobile ? "14px 16px" : "16px 24px",
        paddingBottom: isMobile
          ? "calc(env(safe-area-inset-bottom, 0px) + 14px)"
          : 16,
        background: "linear-gradient(90deg, #0d9488 0%, #0ea5e9 100%)",
        boxShadow: "0 -4px 20px rgba(15, 118, 110, 0.35)",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: "50%",
          flexShrink: 0,
          background: "rgba(255,255,255,0.2)",
          display: isMobile ? "none" : "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FaMagic style={{ color: "#fff", fontSize: 15 }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: isMobile ? 15 : 15,
            fontWeight: 700,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            gap: 8,
            lineHeight: 1.3,
          }}
        >
          {isMobile && <FaMagic style={{ fontSize: 14, flexShrink: 0 }} />}
          <span>{title}</span>
        </div>
        {subtitle && (
          <div
            style={{
              fontSize: 13,
              color: "rgba(255,255,255,0.92)",
              marginTop: 3,
              lineHeight: 1.45,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {ctaLabel && onCta && (
        <button
          onClick={onCta}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: isMobile ? "12px 16px" : "11px 22px",
            borderRadius: 10,
            background: "#fff",
            color: "#0f766e",
            fontSize: 14,
            fontWeight: 700,
            border: "none",
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
            width: isMobile ? "100%" : "auto",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
